// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"Spinner_ldsRing__2cVGW"};